import { render } from "./FastSearchSwitcher.vue?vue&type=template&id=e198db78&scoped=true"
import script from "./FastSearchSwitcher.vue?vue&type=script&lang=js"
export * from "./FastSearchSwitcher.vue?vue&type=script&lang=js"

import "./FastSearchSwitcher.vue?vue&type=style&index=0&id=e198db78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e198db78"]])

export default __exports__